import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { openSubtask } from "~/store/actions/actions.subtasks.jsx";
import { getIsSubtaskCompleted, getSubtaskById } from "~/store/selectors/selector.subtasks.jsx";
import { hasLoggedUserElevatedPermissions } from "~/store/selectors/selector.users.jsx";
import CompletedSubtaskItem from "./CompletedSubtaskItem.jsx";

export const CompletedSubtaskItemContainer = ({ id, isTaskCompleted }) => {
  const dispatch = useDispatch();

  const subtask = useSelector((state) => getSubtaskById(state, id));
  const isSubtaskCompleted = useSelector((state) => getIsSubtaskCompleted(state, id));
  const canModify = useSelector(hasLoggedUserElevatedPermissions);

  const handleOpenSubtask = useCallback(
    (id) => {
      dispatch(openSubtask(id));
    },
    [dispatch]
  );

  return (
    <CompletedSubtaskItem
      id={id}
      name={subtask.name}
      completed={isSubtaskCompleted}
      assigneeId={subtask.assignee_id}
      pending={subtask.pending}
      canModify={canModify}
      onOpenSubtask={handleOpenSubtask}
      isTaskCompleted={isTaskCompleted}
      dueOn={subtask.due_on}
    />
  );
};

CompletedSubtaskItemContainer.propTypes = {
  id: PropTypes.number,
  isTaskCompleted: PropTypes.bool,
};
